import { z } from "zod";
import { zipCodeSchema } from "./generalValidation";

// Address validation schema for popup forms
export const addressSchema = z
  .object({
    address: z.string().min(1, "Street address is required"),
    suiteAddress: z.string().optional(), // Apt, Suite, Fl. is optional
    city: z.string().min(1, "City is required"),
    stateAddress: z.string().min(1, "State is required"),
    zipCode: zipCodeSchema, // Reuse existing zip code validation
    country: z.string().optional().default("US"),
    fromDate: z.string().min(1, "From date is required"),
    toDate: z.string().min(1, "To date is required"),
  })
  .refine(
    (data) => {
      // Validate that fromDate is before toDate
      if (data.fromDate && data.toDate) {
        const fromDate = new Date(data.fromDate);
        const toDate = new Date(data.toDate);
        return fromDate <= toDate;
      }
      return true;
    },
    {
      message: "From date must be before or equal to To date",
      path: ["toDate"],
    }
  );

// Simplified address schema for single address (without dates)
export const singleAddressSchema = z.object({
  address: z.string().min(1, "Street address is required"),
  suiteAddress: z.string().optional(),
  city: z.string().min(1, "City is required"),
  stateAddress: z.string().min(1, "State is required"),
  zipCode: zipCodeSchema,
  country: z.string().optional().default("US"),
});

export default addressSchema;
